import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {InitialResources} from '@gongxigames/framework/core';
import {defaultTexts} from '@gongxigames/framework/slot';

export class InitializeLanguageServiceAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        this.languageService.setTexts(defaultTexts);

        const initialResources = await this.resourceManager.loadInitialResources();
        const {data} = (initialResources as InitialResources).slotLang;

        this.languageService.setTexts(data);
    }

    getName(): string {
        return 'InitializeLanguageServiceAct';
    }
}